<style>
    .save_button{
        display: inline-block;
        min-width: 280px;
        padding: 17px 16px 17px 16px;
        text-align: center;
        border: 0;
        text-transform: uppercase;
        -webkit-transition: all .3s ease;
        transition: all .3s ease;
        cursor: pointer;

        position: fixed;
        bottom: 30pt;
        right: 20pt;
        border-radius: 3px;
        font-size: 12pt;
        padding-left: 30px;
        padding-right: 30px;
        opacity: 0.96;
        white-space: nowrap;
    }

</style>
<template>
    <div>
    	<div id="App_button">
    		<button class="save_button btn-success" data-bs-toggle="modal" data-bs-target=".bs-save-modal-lg">Сохранить</button>
    	</div>
        <div class="modal fade bs-save-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" data-backdrop="static" data-keyboard="false" aria-hidden="true" style="display: none; overflow-y: auto; min-width: 70% !important;">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Инструкция</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" style="text-align: left;">
                <p>Чтобы сохранить документы в PDF перейдите в раздел <a href="#" @click="open_print()">«Печать»</a> (ctrl+P или нажмите Файл->Печать в вашем браузере)</p>
                <button @click="open_print()" type="button" class="btn btn-primary" data-bs-dismiss="modal" style="margin:0 0 10px 0;">Открыть печать</button>
                <ul>
                    <li>1. Вместо принетра выбрать сохранить в PDF ли найти кнопку «Сохраить в PDF»</li>
                    <li>2. Чтобы сохранить документ с подписью и печатью, поставьте галочку «Фон» или «Напечатать фон»</li>
                <img src="../../src/assets/img/insrtuction1.jpg" width="400">
                </ul>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Закрыть</button>
                <button @click="open_print()" type="button" class="btn btn-primary" data-bs-dismiss="modal">Открыть печать</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default{
	name: 'App_button',
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
        open_print(){
            window.print()
        }
    },
    mounted(){
    }
}
</script>